/**
 * Icon component registry — auto-generated from SVG files.
 * DO NOT EDIT MANUALLY — run `node scripts/generate-icon-registry.js` to regenerate.
 *
 * Each SVG is imported as a React component via SVGR.
 * All icons are statically imported into this registry for the <Icon name="..." /> API.
 *
 * To add icons: place .svg files in ./svg/ and re-run this script.
 *
 * Total icons: 215
 */

import type { FC, SVGProps } from 'react';

import AirplaneIcon from './svg/airplane.svg';
import ArchiveIcon from './svg/archive.svg';
import ArrowAntiClockwiseIcon from './svg/arrowAntiClockwise.svg';
import ArrowClockwiseIcon from './svg/arrowClockwise.svg';
import ArrowClockwiseFillIcon from './svg/arrowClockwiseFill.svg';
import ArrowDownSquareIcon from './svg/arrowDownSquare.svg';
import ArrowDownUpIcon from './svg/arrowDownUp.svg';
import ArrowLeftIcon from './svg/arrowLeft.svg';
import ArrowRepeatIcon from './svg/arrowRepeat.svg';
import ArrowRightIcon from './svg/arrowRight.svg';
import ArrowUpSquareIcon from './svg/arrowUpSquare.svg';
import BanIcon from './svg/ban.svg';
import BankNoteArrowDownIcon from './svg/bankNoteArrowDown.svg';
import BarChartLineIcon from './svg/barChartLine.svg';
import BarChartStepsIcon from './svg/barChartSteps.svg';
import BeachIcon from './svg/beach.svg';
import BellIcon from './svg/bell.svg';
import BlockquoteLeftIcon from './svg/blockquoteLeft.svg';
import BoxArrowRightIcon from './svg/boxArrowRight.svg';
import BoxSeamIcon from './svg/boxSeam.svg';
import BuildingIcon from './svg/building.svg';
import BuildingFillIcon from './svg/buildingFill.svg';
import CalendarIcon from './svg/calendar.svg';
import Calendar3Icon from './svg/calendar3.svg';
import CalendarHeartIcon from './svg/calendarHeart.svg';
import CalendarPlus2Icon from './svg/calendarPlus2.svg';
import CalendarWEIcon from './svg/calendarWE.svg';
import CalendarWeekIcon from './svg/calendarWeek.svg';
import CardChecklistIcon from './svg/cardChecklist.svg';
import CardTextIcon from './svg/cardText.svg';
import CastleIcon from './svg/castle.svg';
import ChatIcon from './svg/chat.svg';
import ChatFillIcon from './svg/chatFill.svg';
import CheckIcon from './svg/check.svg';
import CheckCircleIcon from './svg/checkCircle.svg';
import CheckCircleFillIcon from './svg/checkCircleFill.svg';
import CheckLgIcon from './svg/checkLg.svg';
import CheckSquareIcon from './svg/checkSquare.svg';
import ChevronDownIcon from './svg/chevronDown.svg';
import ChevronLeftIcon from './svg/chevronLeft.svg';
import ChevronRightIcon from './svg/chevronRight.svg';
import ChevronUpIcon from './svg/chevronUp.svg';
import CircleIcon from './svg/circle.svg';
import CircleDottedIcon from './svg/circleDotted.svg';
import CircleFPIcon from './svg/circleFP.svg';
import CircleInfoIcon from './svg/circleInfo.svg';
import CircleNIIcon from './svg/circleNI.svg';
import CircleRIIcon from './svg/circleRI.svg';
import CircleSOSIcon from './svg/circleSOS.svg';
import CircleTIcon from './svg/circleT.svg';
import ClockIcon from './svg/clock.svg';
import ClockHistoryIcon from './svg/clockHistory.svg';
import CloseBoldIcon from './svg/closeBold.svg';
import CloudUploadIcon from './svg/cloudUpload.svg';
import CodeSlashIcon from './svg/codeSlash.svg';
import CodeSquareIcon from './svg/codeSquare.svg';
import ColumnsIcon from './svg/columns.svg';
import ColumnsGapIcon from './svg/columnsGap.svg';
import ConnectionFlightIcon from './svg/connectionFlight.svg';
import ConsultantNotesIcon from './svg/consultantNotes.svg';
import ContractNotesIcon from './svg/contractNotes.svg';
import CopyIcon from './svg/copy.svg';
import CreditCardIcon from './svg/creditCard.svg';
import CurrencyDollarIcon from './svg/currencyDollar.svg';
import CurrencyDollarCircleIcon from './svg/currencyDollarCircle.svg';
import CurrencyPoundIcon from './svg/currencyPound.svg';
import DiagramIcon from './svg/diagram.svg';
import DisplayIcon from './svg/display.svg';
import DisplayFillIcon from './svg/displayFill.svg';
import DisplayPhoneIcon from './svg/displayPhone.svg';
import DownloadIcon from './svg/download.svg';
import DownloadTemplateIcon from './svg/downloadTemplate.svg';
import EaselIcon from './svg/easel.svg';
import EditIcon from './svg/edit.svg';
import EmptyStateIllustrationSvg from './svg/emptyStateIllustration.svg';
import EnvelopeIcon from './svg/envelope.svg';
import ExclamationIcon from './svg/exclamation.svg';
import ExclamationCircleIcon from './svg/exclamationCircle.svg';
import ExclamationCircleFillIcon from './svg/exclamationCircleFill.svg';
import ExclamationLgIcon from './svg/exclamationLg.svg';
import ExclamationTriangleIcon from './svg/exclamationTriangle.svg';
import ExclamationTriangleFillIcon from './svg/exclamationTriangleFill.svg';
import EyeIcon from './svg/eye.svg';
import EyeSlashIcon from './svg/eyeSlash.svg';
import FileEarmarkIcon from './svg/fileEarmark.svg';
import FileEarmarkPptIcon from './svg/fileEarmarkPpt.svg';
import FileEarmarkTextIcon from './svg/fileEarmarkText.svg';
import FileSlidersIcon from './svg/fileSliders.svg';
import FileTextIcon from './svg/fileText.svg';
import FilterIcon from './svg/filter.svg';
import FilteringIcon from './svg/filtering.svg';
import FilteringDownIcon from './svg/filteringDown.svg';
import FilteringUpIcon from './svg/filteringUp.svg';
import FlagIcon from './svg/flag.svg';
import FlightCOutlineIcon from './svg/flightCOutline.svg';
import FlightCSolidIcon from './svg/flightCSolid.svg';
import FlightPOutlineIcon from './svg/flightPOutline.svg';
import FlightPSolidIcon from './svg/flightPSolid.svg';
import FullPageErrorIllustrationSvg from './svg/fullPageError.svg';
import FolderOpenIcon from './svg/folderOpen.svg';
import GeoAltIcon from './svg/geoAlt.svg';
import GeoAltFillIcon from './svg/geoAltFill.svg';
import GlobeIcon from './svg/globe.svg';
import GraphDownArrowIcon from './svg/graphDownArrow.svg';
import GraphUpArrowIcon from './svg/graphUpArrow.svg';
import Grid3x3Icon from './svg/grid3x3.svg';
import GripVerticalIcon from './svg/gripVertical.svg';
import HeadsetIcon from './svg/headset.svg';
import HeartFillIcon from './svg/heartFill.svg';
import HeartStrokeIcon from './svg/heartStroke.svg';
import HideCommentsIcon from './svg/hideComments.svg';
import HospitalIcon from './svg/hospital.svg';
import HouseIcon from './svg/house.svg';
import HouseDownIcon from './svg/houseDown.svg';
import ImageIcon from './svg/image.svg';
import InLieuIcon from './svg/inLieu.svg';
import InactivateIcon from './svg/inactivate.svg';
import InfoCircleIcon from './svg/infoCircle.svg';
import InfoCircleFillIcon from './svg/infoCircleFill.svg';
import InfoLgIcon from './svg/infoLg.svg';
import InternalNotesIcon from './svg/internalNotes.svg';
import LaptopIcon from './svg/laptop.svg';
import LayersIcon from './svg/layers.svg';
import LayoutThreeColumnsIcon from './svg/layoutThreeColumns.svg';
import LineCircleFillIcon from './svg/lineCircleFill.svg';
import LinkIcon from './svg/link.svg';
import ListIcon from './svg/list.svg';
import ListOlIcon from './svg/listOl.svg';
import ListUlIcon from './svg/listUl.svg';
import LoadingIcon from './svg/loading.svg';
import LoadingCircleIcon from './svg/loadingCircle.svg';
import LockIcon from './svg/lock.svg';
import LockFillIcon from './svg/lockFill.svg';
import LogInIcon from './svg/logIn.svg';
import ManageIcon from './svg/manage.svg';
import MinusIcon from './svg/minus.svg';
import NoDataIllustrationSvg from './svg/noData.svg';
import NoDataSearchIllustrationSvg from './svg/noDataSearch.svg';
import NoResultsFoundIllustrationSvg from './svg/noResultsFound.svg';
import NextIcon from './svg/next.svg';
import OpenInNewIcon from './svg/openInNew.svg';
import PanelLeftCloseIcon from './svg/panelLeftClose.svg';
import PanelLeftOpenIcon from './svg/panelLeftOpen.svg';
import PauseCircleIcon from './svg/pauseCircle.svg';
import PencilSquareIcon from './svg/pencilSquare.svg';
import PeopleIcon from './svg/people.svg';
import PersonIcon from './svg/person.svg';
import PersonBackIcon from './svg/personBack.svg';
import PersonBoundingBoxIcon from './svg/personBoundingBox.svg';
import PersonFillIcon from './svg/personFill.svg';
import PersonFillAddIcon from './svg/personFillAdd.svg';
import PersonFillDashIcon from './svg/personFillDash.svg';
import PersonFillGearIcon from './svg/personFillGear.svg';
import PersonFillUpIcon from './svg/personFillUp.svg';
import PersonGearIcon from './svg/personGear.svg';
import PersonWorkspaceIcon from './svg/personWorkspace.svg';
import PhoneIcon from './svg/phone.svg';
import PhoneFillIcon from './svg/phoneFill.svg';
import PlayCircleIcon from './svg/playCircle.svg';
import PlusIcon from './svg/plus.svg';
import PlusBoldIcon from './svg/plusBold.svg';
import PlusCircleIcon from './svg/plusCircle.svg';
import PlusLgIcon from './svg/plusLg.svg';
import PrevIcon from './svg/prev.svg';
import ProgressIcon from './svg/progress.svg';
import QuestionCircleIcon from './svg/questionCircle.svg';
import ReactivateRefreshIcon from './svg/reactivateRefresh.svg';
import ReceiptTextIcon from './svg/receiptText.svg';
import SaveIcon from './svg/save.svg';
import SearchIcon from './svg/search.svg';
import SearchShadowIcon from './svg/searchShadow.svg';
import SendIcon from './svg/send.svg';
import SendRepeatV1Icon from './svg/sendRepeatV1.svg';
import SendRepeatV2Icon from './svg/sendRepeatV2.svg';
import SettingsIcon from './svg/settings.svg';
import ShadowsIcon from './svg/shadows.svg';
import ShoppingCartIcon from './svg/shoppingCart.svg';
import SlashCircleFillIcon from './svg/slashCircleFill.svg';
import SlidersIcon from './svg/sliders.svg';
import SofaIcon from './svg/sofa.svg';
import SolidArrowDownIcon from './svg/solidArrowDown.svg';
import SolidArrowLeftIcon from './svg/solidArrowLeft.svg';
import SolidArrowRightIcon from './svg/solidArrowRight.svg';
import SolidArrowUpIcon from './svg/solidArrowUp.svg';
import SortAppliedAscIcon from './svg/sortAppliedAsc.svg';
import SortAppliedDescIcon from './svg/sortAppliedDesc.svg';
import SortDownIcon from './svg/sortDown.svg';
import SortDownAltIcon from './svg/sortDownAlt.svg';
import SortDownDefaultIcon from './svg/sortDownDefault.svg';
import SortingIcon from './svg/sorting.svg';
import SosIcon from './svg/sos.svg';
import StarsIcon from './svg/stars.svg';
import StickyIcon from './svg/sticky.svg';
import SuitcaseIcon from './svg/suitcase.svg';
import SunglassesIcon from './svg/sunglasses.svg';
import SuperNextIcon from './svg/superNext.svg';
import SuperPrevIcon from './svg/superPrev.svg';
import TableIcon from './svg/table.svg';
import TelephoneIcon from './svg/telephone.svg';
import TelephoneFillIcon from './svg/telephoneFill.svg';
import ThreeDotsIcon from './svg/threeDots.svg';
import ThreeDotsFillIcon from './svg/threeDotsFill.svg';
import ThumbsDownIcon from './svg/thumbsDown.svg';
import ThumbsUpIcon from './svg/thumbsUp.svg';
import ThumbsUpSolidIcon from './svg/thumbsUpSolid.svg';
import TimelineIcon from './svg/timeline.svg';
import TrashIcon from './svg/trash.svg';
import TrashCanIcon from './svg/trashCan.svg';
import TrashFillIcon from './svg/trashFill.svg';
import TypeBoldIcon from './svg/typeBold.svg';
import TypeH1Icon from './svg/typeH1.svg';
import TypeItalicIcon from './svg/typeItalic.svg';
import TypeStrikethroughIcon from './svg/typeStrikethrough.svg';
import TypeUnderlineIcon from './svg/typeUnderline.svg';
import UploadIcon from './svg/upload.svg';
import WeekendIcon from './svg/weekend.svg';
import XIcon from './svg/x.svg';
import XCircleFillIcon from './svg/xCircleFill.svg';
import XLgIcon from './svg/xLg.svg';
import XOctagonIcon from './svg/xOctagon.svg';

/**
 * Union type of all available icon names.
 * Provides type-safe autocompletion when using the Icon component.
 */
export type IconName =
	| 'airplane'
	| 'archive'
	| 'arrowAntiClockwise'
	| 'arrowClockwise'
	| 'arrowClockwiseFill'
	| 'arrowDownSquare'
	| 'arrowDownUp'
	| 'arrowLeft'
	| 'arrowRepeat'
	| 'arrowRight'
	| 'arrowUpSquare'
	| 'ban'
	| 'bankNoteArrowDown'
	| 'barChartLine'
	| 'barChartSteps'
	| 'beach'
	| 'bell'
	| 'blockquoteLeft'
	| 'boxArrowRight'
	| 'boxSeam'
	| 'building'
	| 'buildingFill'
	| 'calendar'
	| 'calendar3'
	| 'calendarHeart'
	| 'calendarPlus2'
	| 'calendarWE'
	| 'calendarWeek'
	| 'cardChecklist'
	| 'cardText'
	| 'castle'
	| 'chat'
	| 'chatFill'
	| 'check'
	| 'checkCircle'
	| 'checkCircleFill'
	| 'checkLg'
	| 'checkSquare'
	| 'chevronDown'
	| 'chevronLeft'
	| 'chevronRight'
	| 'chevronUp'
	| 'circle'
	| 'circleDotted'
	| 'circleFP'
	| 'circleInfo'
	| 'circleNI'
	| 'circleRI'
	| 'circleSOS'
	| 'circleT'
	| 'clock'
	| 'clockHistory'
	| 'closeBold'
	| 'cloudUpload'
	| 'codeSlash'
	| 'codeSquare'
	| 'columns'
	| 'columnsGap'
	| 'connectionFlight'
	| 'consultantNotes'
	| 'contractNotes'
	| 'copy'
	| 'creditCard'
	| 'currencyDollar'
	| 'currencyDollarCircle'
	| 'currencyPound'
	| 'diagram'
	| 'display'
	| 'displayFill'
	| 'displayPhone'
	| 'download'
	| 'downloadTemplate'
	| 'easel'
	| 'edit'
	| 'envelope'
	| 'exclamation'
	| 'exclamationCircle'
	| 'exclamationCircleFill'
	| 'exclamationLg'
	| 'exclamationTriangle'
	| 'exclamationTriangleFill'
	| 'eye'
	| 'eyeSlash'
	| 'fileEarmark'
	| 'fileEarmarkPpt'
	| 'fileEarmarkText'
	| 'fileSliders'
	| 'fileText'
	| 'filter'
	| 'filtering'
	| 'filteringDown'
	| 'filteringUp'
	| 'flag'
	| 'flightCOutline'
	| 'flightCSolid'
	| 'flightPOutline'
	| 'flightPSolid'
	| 'folderOpen'
	| 'geoAlt'
	| 'geoAltFill'
	| 'globe'
	| 'graphDownArrow'
	| 'graphUpArrow'
	| 'grid3x3'
	| 'gripVertical'
	| 'headset'
	| 'heartFill'
	| 'heartStroke'
	| 'hideComments'
	| 'hospital'
	| 'house'
	| 'houseDown'
	| 'image'
	| 'inLieu'
	| 'inactivate'
	| 'infoCircle'
	| 'infoCircleFill'
	| 'infoLg'
	| 'internalNotes'
	| 'laptop'
	| 'layers'
	| 'layoutThreeColumns'
	| 'lineCircleFill'
	| 'link'
	| 'list'
	| 'listOl'
	| 'listUl'
	| 'loading'
	| 'loadingCircle'
	| 'lock'
	| 'lockFill'
	| 'logIn'
	| 'manage'
	| 'minus'
	| 'next'
	| 'openInNew'
	| 'panelLeftClose'
	| 'panelLeftOpen'
	| 'pauseCircle'
	| 'pencilSquare'
	| 'people'
	| 'person'
	| 'personBack'
	| 'personBoundingBox'
	| 'personFill'
	| 'personFillAdd'
	| 'personFillDash'
	| 'personFillGear'
	| 'personFillUp'
	| 'personGear'
	| 'personWorkspace'
	| 'phone'
	| 'phoneFill'
	| 'playCircle'
	| 'plus'
	| 'plusBold'
	| 'plusCircle'
	| 'plusLg'
	| 'prev'
	| 'progress'
	| 'questionCircle'
	| 'reactivateRefresh'
	| 'receiptText'
	| 'save'
	| 'search'
	| 'searchShadow'
	| 'send'
	| 'sendRepeatV1'
	| 'sendRepeatV2'
	| 'settings'
	| 'shadows'
	| 'shoppingCart'
	| 'slashCircleFill'
	| 'sliders'
	| 'sofa'
	| 'solidArrowDown'
	| 'solidArrowLeft'
	| 'solidArrowRight'
	| 'solidArrowUp'
	| 'sortAppliedAsc'
	| 'sortAppliedDesc'
	| 'sortDown'
	| 'sortDownAlt'
	| 'sortDownDefault'
	| 'sorting'
	| 'sos'
	| 'stars'
	| 'sticky'
	| 'suitcase'
	| 'sunglasses'
	| 'superNext'
	| 'superPrev'
	| 'table'
	| 'telephone'
	| 'telephoneFill'
	| 'threeDots'
	| 'threeDotsFill'
	| 'thumbsDown'
	| 'thumbsUp'
	| 'thumbsUpSolid'
	| 'timeline'
	| 'trash'
	| 'trashCan'
	| 'trashFill'
	| 'typeBold'
	| 'typeH1'
	| 'typeItalic'
	| 'typeStrikethrough'
	| 'typeUnderline'
	| 'upload'
	| 'weekend'
	| 'x'
	| 'xCircleFill'
	| 'xLg'
	| 'xOctagon';

/** SVG component type returned by SVGR. */
export type ISvgIcon = FC<SVGProps<SVGSVGElement>>;

/**
 * Registry mapping icon names to their SVGR React components.
 * Used by the Icon component to render the correct SVG.
 */
export const ICON_REGISTRY: Record<IconName, ISvgIcon> = {
	airplane: AirplaneIcon,
	archive: ArchiveIcon,
	arrowAntiClockwise: ArrowAntiClockwiseIcon,
	arrowClockwise: ArrowClockwiseIcon,
	arrowClockwiseFill: ArrowClockwiseFillIcon,
	arrowDownSquare: ArrowDownSquareIcon,
	arrowDownUp: ArrowDownUpIcon,
	arrowLeft: ArrowLeftIcon,
	arrowRepeat: ArrowRepeatIcon,
	arrowRight: ArrowRightIcon,
	arrowUpSquare: ArrowUpSquareIcon,
	ban: BanIcon,
	bankNoteArrowDown: BankNoteArrowDownIcon,
	barChartLine: BarChartLineIcon,
	barChartSteps: BarChartStepsIcon,
	beach: BeachIcon,
	bell: BellIcon,
	blockquoteLeft: BlockquoteLeftIcon,
	boxArrowRight: BoxArrowRightIcon,
	boxSeam: BoxSeamIcon,
	building: BuildingIcon,
	buildingFill: BuildingFillIcon,
	calendar: CalendarIcon,
	calendar3: Calendar3Icon,
	calendarHeart: CalendarHeartIcon,
	calendarPlus2: CalendarPlus2Icon,
	calendarWE: CalendarWEIcon,
	calendarWeek: CalendarWeekIcon,
	cardChecklist: CardChecklistIcon,
	cardText: CardTextIcon,
	castle: CastleIcon,
	chat: ChatIcon,
	chatFill: ChatFillIcon,
	check: CheckIcon,
	checkCircle: CheckCircleIcon,
	checkCircleFill: CheckCircleFillIcon,
	checkLg: CheckLgIcon,
	checkSquare: CheckSquareIcon,
	chevronDown: ChevronDownIcon,
	chevronLeft: ChevronLeftIcon,
	chevronRight: ChevronRightIcon,
	chevronUp: ChevronUpIcon,
	circle: CircleIcon,
	circleDotted: CircleDottedIcon,
	circleFP: CircleFPIcon,
	circleInfo: CircleInfoIcon,
	circleNI: CircleNIIcon,
	circleRI: CircleRIIcon,
	circleSOS: CircleSOSIcon,
	circleT: CircleTIcon,
	clock: ClockIcon,
	clockHistory: ClockHistoryIcon,
	closeBold: CloseBoldIcon,
	cloudUpload: CloudUploadIcon,
	codeSlash: CodeSlashIcon,
	codeSquare: CodeSquareIcon,
	columns: ColumnsIcon,
	columnsGap: ColumnsGapIcon,
	connectionFlight: ConnectionFlightIcon,
	consultantNotes: ConsultantNotesIcon,
	contractNotes: ContractNotesIcon,
	copy: CopyIcon,
	creditCard: CreditCardIcon,
	currencyDollar: CurrencyDollarIcon,
	currencyDollarCircle: CurrencyDollarCircleIcon,
	currencyPound: CurrencyPoundIcon,
	diagram: DiagramIcon,
	display: DisplayIcon,
	displayFill: DisplayFillIcon,
	displayPhone: DisplayPhoneIcon,
	download: DownloadIcon,
	downloadTemplate: DownloadTemplateIcon,
	easel: EaselIcon,
	edit: EditIcon,
	envelope: EnvelopeIcon,
	exclamation: ExclamationIcon,
	exclamationCircle: ExclamationCircleIcon,
	exclamationCircleFill: ExclamationCircleFillIcon,
	exclamationLg: ExclamationLgIcon,
	exclamationTriangle: ExclamationTriangleIcon,
	exclamationTriangleFill: ExclamationTriangleFillIcon,
	eye: EyeIcon,
	eyeSlash: EyeSlashIcon,
	fileEarmark: FileEarmarkIcon,
	fileEarmarkPpt: FileEarmarkPptIcon,
	fileEarmarkText: FileEarmarkTextIcon,
	fileSliders: FileSlidersIcon,
	fileText: FileTextIcon,
	filter: FilterIcon,
	filtering: FilteringIcon,
	filteringDown: FilteringDownIcon,
	filteringUp: FilteringUpIcon,
	flag: FlagIcon,
	flightCOutline: FlightCOutlineIcon,
	flightCSolid: FlightCSolidIcon,
	flightPOutline: FlightPOutlineIcon,
	flightPSolid: FlightPSolidIcon,
	folderOpen: FolderOpenIcon,
	geoAlt: GeoAltIcon,
	geoAltFill: GeoAltFillIcon,
	globe: GlobeIcon,
	graphDownArrow: GraphDownArrowIcon,
	graphUpArrow: GraphUpArrowIcon,
	grid3x3: Grid3x3Icon,
	gripVertical: GripVerticalIcon,
	headset: HeadsetIcon,
	heartFill: HeartFillIcon,
	heartStroke: HeartStrokeIcon,
	hideComments: HideCommentsIcon,
	hospital: HospitalIcon,
	house: HouseIcon,
	houseDown: HouseDownIcon,
	image: ImageIcon,
	inLieu: InLieuIcon,
	inactivate: InactivateIcon,
	infoCircle: InfoCircleIcon,
	infoCircleFill: InfoCircleFillIcon,
	infoLg: InfoLgIcon,
	internalNotes: InternalNotesIcon,
	laptop: LaptopIcon,
	layers: LayersIcon,
	layoutThreeColumns: LayoutThreeColumnsIcon,
	lineCircleFill: LineCircleFillIcon,
	link: LinkIcon,
	list: ListIcon,
	listOl: ListOlIcon,
	listUl: ListUlIcon,
	loading: LoadingIcon,
	loadingCircle: LoadingCircleIcon,
	lock: LockIcon,
	lockFill: LockFillIcon,
	logIn: LogInIcon,
	manage: ManageIcon,
	minus: MinusIcon,
	next: NextIcon,
	openInNew: OpenInNewIcon,
	panelLeftClose: PanelLeftCloseIcon,
	panelLeftOpen: PanelLeftOpenIcon,
	pauseCircle: PauseCircleIcon,
	pencilSquare: PencilSquareIcon,
	people: PeopleIcon,
	person: PersonIcon,
	personBack: PersonBackIcon,
	personBoundingBox: PersonBoundingBoxIcon,
	personFill: PersonFillIcon,
	personFillAdd: PersonFillAddIcon,
	personFillDash: PersonFillDashIcon,
	personFillGear: PersonFillGearIcon,
	personFillUp: PersonFillUpIcon,
	personGear: PersonGearIcon,
	personWorkspace: PersonWorkspaceIcon,
	phone: PhoneIcon,
	phoneFill: PhoneFillIcon,
	playCircle: PlayCircleIcon,
	plus: PlusIcon,
	plusBold: PlusBoldIcon,
	plusCircle: PlusCircleIcon,
	plusLg: PlusLgIcon,
	prev: PrevIcon,
	progress: ProgressIcon,
	questionCircle: QuestionCircleIcon,
	receiptText: ReceiptTextIcon,
	reactivateRefresh: ReactivateRefreshIcon,
	save: SaveIcon,
	search: SearchIcon,
	searchShadow: SearchShadowIcon,
	send: SendIcon,
	sendRepeatV1: SendRepeatV1Icon,
	sendRepeatV2: SendRepeatV2Icon,
	settings: SettingsIcon,
	shadows: ShadowsIcon,
	shoppingCart: ShoppingCartIcon,
	slashCircleFill: SlashCircleFillIcon,
	sliders: SlidersIcon,
	sofa: SofaIcon,
	solidArrowDown: SolidArrowDownIcon,
	solidArrowLeft: SolidArrowLeftIcon,
	solidArrowRight: SolidArrowRightIcon,
	solidArrowUp: SolidArrowUpIcon,
	sortAppliedAsc: SortAppliedAscIcon,
	sortAppliedDesc: SortAppliedDescIcon,
	sortDown: SortDownIcon,
	sortDownAlt: SortDownAltIcon,
	sortDownDefault: SortDownDefaultIcon,
	sorting: SortingIcon,
	sos: SosIcon,
	stars: StarsIcon,
	sticky: StickyIcon,
	suitcase: SuitcaseIcon,
	sunglasses: SunglassesIcon,
	superNext: SuperNextIcon,
	superPrev: SuperPrevIcon,
	table: TableIcon,
	telephone: TelephoneIcon,
	telephoneFill: TelephoneFillIcon,
	threeDots: ThreeDotsIcon,
	threeDotsFill: ThreeDotsFillIcon,
	thumbsDown: ThumbsDownIcon,
	thumbsUp: ThumbsUpIcon,
	thumbsUpSolid: ThumbsUpSolidIcon,
	timeline: TimelineIcon,
	trash: TrashIcon,
	trashCan: TrashCanIcon,
	trashFill: TrashFillIcon,
	typeBold: TypeBoldIcon,
	typeH1: TypeH1Icon,
	typeItalic: TypeItalicIcon,
	typeStrikethrough: TypeStrikethroughIcon,
	typeUnderline: TypeUnderlineIcon,
	upload: UploadIcon,
	weekend: WeekendIcon,
	x: XIcon,
	xCircleFill: XCircleFillIcon,
	xLg: XLgIcon,
	xOctagon: XOctagonIcon,
};

/** Array of all available icon names, useful for iteration in stories/docs. */
export const ICON_NAMES: readonly IconName[] = [
	'airplane',
	'archive',
	'arrowAntiClockwise',
	'arrowClockwise',
	'arrowClockwiseFill',
	'arrowDownSquare',
	'arrowDownUp',
	'arrowLeft',
	'arrowRepeat',
	'arrowRight',
	'arrowUpSquare',
	'ban',
	'bankNoteArrowDown',
	'barChartLine',
	'barChartSteps',
	'beach',
	'bell',
	'blockquoteLeft',
	'boxArrowRight',
	'boxSeam',
	'building',
	'buildingFill',
	'calendar',
	'calendar3',
	'calendarHeart',
	'calendarPlus2',
	'calendarWE',
	'calendarWeek',
	'cardChecklist',
	'cardText',
	'castle',
	'chat',
	'chatFill',
	'check',
	'checkCircle',
	'checkCircleFill',
	'checkLg',
	'checkSquare',
	'chevronDown',
	'chevronLeft',
	'chevronRight',
	'chevronUp',
	'circle',
	'circleDotted',
	'circleFP',
	'circleInfo',
	'circleNI',
	'circleRI',
	'circleSOS',
	'circleT',
	'clock',
	'clockHistory',
	'closeBold',
	'cloudUpload',
	'codeSlash',
	'codeSquare',
	'columns',
	'columnsGap',
	'connectionFlight',
	'consultantNotes',
	'contractNotes',
	'copy',
	'creditCard',
	'currencyDollar',
	'currencyDollarCircle',
	'currencyPound',
	'diagram',
	'display',
	'displayFill',
	'displayPhone',
	'download',
	'downloadTemplate',
	'easel',
	'edit',
	'envelope',
	'exclamation',
	'exclamationCircle',
	'exclamationCircleFill',
	'exclamationLg',
	'exclamationTriangle',
	'exclamationTriangleFill',
	'eye',
	'eyeSlash',
	'fileEarmark',
	'fileEarmarkPpt',
	'fileEarmarkText',
	'fileSliders',
	'fileText',
	'filter',
	'filtering',
	'filteringDown',
	'filteringUp',
	'flag',
	'flightCOutline',
	'flightCSolid',
	'flightPOutline',
	'flightPSolid',
	'folderOpen',
	'geoAlt',
	'geoAltFill',
	'globe',
	'graphDownArrow',
	'graphUpArrow',
	'grid3x3',
	'gripVertical',
	'headset',
	'heartFill',
	'heartStroke',
	'hideComments',
	'hospital',
	'house',
	'houseDown',
	'image',
	'inLieu',
	'inactivate',
	'infoCircle',
	'infoCircleFill',
	'infoLg',
	'internalNotes',
	'laptop',
	'layers',
	'layoutThreeColumns',
	'lineCircleFill',
	'link',
	'list',
	'listOl',
	'listUl',
	'loading',
	'loadingCircle',
	'lock',
	'lockFill',
	'logIn',
	'manage',
	'minus',
	'next',
	'openInNew',
	'panelLeftClose',
	'panelLeftOpen',
	'pauseCircle',
	'pencilSquare',
	'people',
	'person',
	'personBoundingBox',
	'personBack',
	'personFill',
	'personFillAdd',
	'personFillDash',
	'personFillGear',
	'personFillUp',
	'personGear',
	'personWorkspace',
	'phone',
	'phoneFill',
	'playCircle',
	'plus',
	'plusBold',
	'plusCircle',
	'plusLg',
	'prev',
	'progress',
	'questionCircle',
	'reactivateRefresh',
	'receiptText',
	'save',
	'search',
	'searchShadow',
	'send',
	'sendRepeatV1',
	'sendRepeatV2',
	'settings',
	'shadows',
	'shoppingCart',
	'slashCircleFill',
	'sliders',
	'sofa',
	'solidArrowDown',
	'solidArrowLeft',
	'solidArrowRight',
	'solidArrowUp',
	'sortAppliedAsc',
	'sortAppliedDesc',
	'sortDown',
	'sortDownAlt',
	'sortDownDefault',
	'sorting',
	'sos',
	'stars',
	'sticky',
	'suitcase',
	'sunglasses',
	'superNext',
	'superPrev',
	'table',
	'telephone',
	'telephoneFill',
	'threeDots',
	'threeDotsFill',
	'thumbsDown',
	'thumbsUp',
	'thumbsUpSolid',
	'timeline',
	'trash',
	'trashCan',
	'trashFill',
	'typeBold',
	'typeH1',
	'typeItalic',
	'typeStrikethrough',
	'typeUnderline',
	'upload',
	'weekend',
	'x',
	'xCircleFill',
	'xLg',
	'xOctagon',
] as const satisfies readonly IconName[];

/** Illustrations — not in ICON_REGISTRY (too large for the Icon component's fixed sizes). */
export const EmptyStateIllustration = EmptyStateIllustrationSvg;
export const FullPageErrorIllustration = FullPageErrorIllustrationSvg;
export const NoDataIllustration = NoDataIllustrationSvg;
export const NoDataSearchIllustration = NoDataSearchIllustrationSvg;
export const NoResultsFoundIllustration = NoResultsFoundIllustrationSvg;
